export default __webpack_public_path__ + "static/media/directory_dark.7d1bb6f6.svg";